var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgb(218, 0, 38)",
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M461.7 80.7C387.4 67.2 320.9 37.5 261.5 2.1a11.2 11.2 0 0 0-11 0C191 37.5 124.6 67.2 50.3 80.7a11 11 0 0 0-9.1 10.8v152.2c0 64.2 24.6 122.4 73.1 173 37 38.5 88.3 73.9 137.3 94.6a11.1 11.1 0 0 0 8.6 0c49-20.7 100.3-56.1 137.3-94.6 48.5-50.6 73.1-108.8 73.1-173V91.5a11 11 0 0 0-9-10.8zM448.6 243.7c0 119.4-103.5 188.3-192.6 227.2-89.1-38.9-192.6-107.8-192.6-227.2V100.7C133.7 86.1 197.3 57.4 256 24.6c58.7 32.8 122.3 61.5 192.6 76.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.4 287.5l-43.6-43.6a11.3 11.3 0 0 0-16 0 11.3 11.3 0 0 0 0 16l51.6 51.6a11.3 11.3 0 0 0 16 0l108.8-108.8a11.3 11.3 0 0 0 0-16 11.3 11.3 0 0 0-16 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.cbfee7874bc551aedbb7c2fc6c84db46.svg";
export { ForwardRef as ReactComponent };